module.exports = __webpack_public_path__ + "img/discount-shape copy.ede7b742.png";